import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import WashingServices from "./pages/WashingServices";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";

import "./App.css";

function App() {

  /* Scroll Top Button */

  const [visible, setVisible] = useState(false);

  useEffect(() => {

    const toggleVisible = () => {

      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }

    };

    window.addEventListener("scroll", toggleVisible);

    return () => window.removeEventListener("scroll", toggleVisible);

  }, []);

  /* Scroll Function */

  const scrollToTop = () => {

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

  };

  return (

    <BrowserRouter>

      {/* Navbar */}

      <Navbar />

      {/* Routes */}

      <Routes>

        <Route path="/" element={<Home />} />

        <Route path="/about" element={<About />} />
        
        <Route path="/contact" element={<Contact   />} />
        <Route path="/washing-machine-service" element={<WashingServices   />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy   />} />
        <Route path="/terms-and-conditions" element={<Terms   />} />


      </Routes>

      {/* Footer */}

      <Footer />

      {/* Call Button */}

      <a
        href="tel:+919790066906"
        className="call-button"
      >
        <FaPhoneAlt />
      </a>

      {/* Scroll Top Button */}

      {visible && (

        <button
          className="scroll-top-btn"
          onClick={scrollToTop}
        >
          ↑
        </button>

      )}

    </BrowserRouter>

  );

}

export default App;